import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CalendarCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-list.response';
import { MyCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/cultivation/my-cultivation-list.response';
import { TranslatePipe } from '@ngx-translate/core';
import { CalendarPeriodLineComponent } from './calendar-period-line/calendar-period-line.component';
import { CultivationItemViewerComponent } from '../../../../../garden/@components/hierarchy-item/cultivation-item-viewer/cultivation-item-viewer.component';
import { ChevronRightIconComponent } from '../../../../../@icons/chevron-right.component';
import { ShelterablePeriod } from '../../../../../@commons/@services/front/period-bars.util';

/** Ce que la personne a déjà de cette culture : des graines, ou des plantes au potager. */
export type CalendarBadge = 'stock' | 'garden' | null;

/**
 * Une ligne serrée du calendrier : à gauche la culture et son badge (« En
 * stock », « Au potager »), à droite ses barres de période sur la grille des
 * mois ; le trait d'aujourd'hui traverse la liste entière, pas chaque ligne.
 * Toute la ligne se touche.
 */
@Component({
  selector: 'vw-calendar-hierarchy-card-item',
  imports: [CalendarPeriodLineComponent, CultivationItemViewerComponent, ChevronRightIconComponent, TranslatePipe],
  templateUrl: './calendar-hierarchy-card-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './calendar-hierarchy-card-item.component.scss',
})
export class CalendarHierarchyCardItemComponent {
  @Input() cultivation!: MyCultivationListResponse | CalendarCultivationListResponse;
  @Input() name: string;
  @Input() type: 'cultivation' | 'hierarchy';
  @Input() periods: ShelterablePeriod[] = [];
  @Input() isOpen: boolean;
  @Input() badge: CalendarBadge = null;
  @Output() clickItem: EventEmitter<void> = new EventEmitter();

  readonly monthNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  onClick() {
    this.clickItem.emit();
  }
}
